import React, { memo } from 'react';
import { CircularProgress, Dialog } from '@mui/material';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import styles from './styles';
import * as Constant from '../../../constants/actionTypes';
import { labelName } from '../../UtilsWeb';

const Loading = ({ classes }) => (
  <Dialog open aria-labelledby="simple-dialog-title">
    <div className={classes.loaderStyle}>
      <CircularProgress />
      <p className={classes.labelLoadingStyle}>{labelName(Constant.LABEL_LOADING)}</p>
    </div>
  </Dialog>
);

Loading.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default memo(withStyles(styles)(Loading));
